var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompletedStatusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM11.8889 6.70711C12.2794 6.31658 12.2794 5.68342 11.8889 5.29289C11.4984 4.90237 10.8652 4.90237 10.4747 5.29289L7.60608 8.16152C7.39641 8.3712 7.28113 8.48538 7.19195 8.56108L7.18182 8.5696L7.17168 8.56108C7.08251 8.48538 6.96723 8.3712 6.75755 8.16152L5.70711 7.11108C5.31658 6.72055 4.68342 6.72055 4.29289 7.11108C3.90237 7.5016 3.90237 8.13476 4.29289 8.52529L5.34334 9.57574L5.36589 9.59829C5.54433 9.77677 5.71811 9.9506 5.87733 10.0858C6.05218 10.2342 6.27407 10.3938 6.56378 10.4879C6.96547 10.6184 7.39817 10.6184 7.79985 10.4879C8.08957 10.3938 8.31146 10.2342 8.48631 10.0858C8.64552 9.9506 8.8193 9.77678 8.99774 9.5983L9.0203 9.57574L11.8889 6.70711Z",
    fill: "#00AB21"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompletedStatusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/completed-status-icon.8463b9ddecd0cd078424707d83bf7cf7.svg";